/* eslint-disable react-hooks/exhaustive-deps */
import { ApolloQueryResult } from '@apollo/client';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { IDirectoryVariables, IMainDirectoryQueryResults, useLazyMainDirectoryQuery } from '../graphql/useMainDirectoryQuery';
import reducer, { ReducerAction, Workspace } from './DirectoryReducer';

interface IDispatchContext {
    dispatch: React.Dispatch<ReducerAction>
}

const StateContext = React.createContext<Workspace>({} as Workspace);
const DispatchContext = React.createContext<IDispatchContext>({} as IDispatchContext);

export const useDirectoryState = () => React.useContext(StateContext);
export const useDirectoryDispatch = () => React.useContext(DispatchContext);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useAsyncReducer(reducer: any, initState: any, events: (variables: IDirectoryVariables) => Promise<ApolloQueryResult<IMainDirectoryQueryResults>>) {
    const [state, setState] = useState(initState),

        dispatchState = async (action: ReducerAction) => setState(await reducer(state, action, events));

    return [state, dispatchState];
}

export const DirectoryState = ({ children }: { children: React.ReactNode }) => {
    const query = useLazyMainDirectoryQuery();
    const [state, dispatch] = useAsyncReducer(reducer, { initialLoading: true }, query);

    useEffect(() => {
        dispatch({ type: 'LOAD_DIRECTORY' });
    }, []);

    return (
        <DispatchContext.Provider value={{ dispatch }}>
            <StateContext.Provider value={state}>{children}</StateContext.Provider>
        </DispatchContext.Provider>
    );
};
